// Dashboard Data
const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE';

const DASHBOARDLISTDATA='DASHBOARDLISTDATA';
export {
    DASHBOARD_REQUEST, DASHBOARD_SUCCESS, DASHBOARD_FAILURE,DASHBOARDLISTDATA,
};